import { render, staticRenderFns } from "./ItemsHorizontalList.vue?vue&type=template&id=1aa6dc66&"
import script from "./ItemsHorizontalList.vue?vue&type=script&lang=ts&"
export * from "./ItemsHorizontalList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports